module.exports = "<div id=\"contact-us\">\n\tCan't find what you're looking for? We can help. <a href=\"#\" ng-click=\"concierge()\">Contact a Tablelist concierge</a>, or text us at (617)-340-8791\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/contactUs/template.html
// module id = 843
// module chunks = 1